import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useRef, useContext } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import styles from './index.module.scss';

import actions from '@/actions';
import { PrimaryButton } from '@/components/ui/kit/Button';
import { MissionTableContent } from '@/components/ui/MissionTable';
import { MissionTableProvider, MissionTableContext } from '@/components/ui/MissionTable/MissionTableContext';
import { getMission } from '@/helpers/Requester';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const MissionBrowserContent = ({ active, onDone, doLoad, originMission, isLoadingMission }) => {
  const { load, clearSelection } = useContext(MissionTableContext);
  const store = useStore();
  const dispatch = useDispatch();

  useUpdateEffect(() => {
    // 미션 브라우저 오픈 시
    if (active) {
      load();
      // 현재 미션 보관
      originMission.current = { ...store.getState().mission };

      dispatch(actions.mission.reset());
    }
    // 미션 브라우저 닫기 시
    else {
      clearSelection();

      // Load 버튼이 아닌 Cancel 버튼으로 닫힌 경우 보관된 미션 복원
      if (!isLoadingMission.current) {
        dispatch(actions.mission.load(originMission.current));
      }

      originMission.current = null;
      isLoadingMission.current = false;
    }

    dispatch(actions.editor.changeMode(null));
    dispatch(actions.editor.setEnabled(!active));
  }, [active]);

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Missions</div>
      </div>
      <MissionTableContent className={cx('body')} />
      <div className={cx('bottom')}>
        <PrimaryButton text="Cancel" onClick={onDone} />
        <PrimaryButton text="Load" accent onClick={doLoad} />
      </div>
    </div>
  );
};

const MissionBrowser = ({ active, onDone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedMissionId = useRef();
  const originMission = useRef();
  const isLoadingMission = useRef(false);

  const handleSelect = (mission) => {
    // 미션 선택 해제된 경우 (예: 미션 삭제)
    if (!mission) {
      dispatch(actions.mission.reset());
      selectedMissionId.current = null;
      return;
    }

    getMission(mission.id).then(({ success, data }) => {
      if (success) {
        selectedMissionId.current = data.id;
        dispatch(actions.mission.load(data));
      }
    });
  };

  const doLoad = () => {
    if (!selectedMissionId.current) {
      notifier.error('Please select a mission.');
      return;
    }
    if (selectedMissionId.current === originMission.current.id) {
      notifier.error('This mission is already loaded.');
      return;
    }

    isLoadingMission.current = true;
    onDone();
    navigate(`/mission-hub/${selectedMissionId.current}`, { replace: true });
  };

  return (
    <MissionTableProvider onSelectMission={handleSelect}>
      <MissionBrowserContent
        active={active}
        onDone={onDone}
        doLoad={doLoad}
        originMission={originMission}
        isLoadingMission={isLoadingMission}
      />
    </MissionTableProvider>
  );
};

export default MissionBrowser;
